import { useState } from 'react'
import { UserRound } from 'lucide-react'
import { cn } from '../../lib/format.js'

const SIZES = { sm: 'size-7 text-[11px]', md: 'size-9 text-xs', lg: 'size-12 text-sm', xl: 'size-20 text-xl sm:size-32 sm:text-3xl' }
const TONES = ['bg-sky-500/20 text-sky-200', 'bg-amber-500/20 text-amber-200', 'bg-emerald-500/20 text-emerald-200', 'bg-fuchsia-500/20 text-fuchsia-200', 'bg-rose-500/20 text-rose-200']

function initials(name = '') {
  const words = name.trim().split(/\s+/).filter(Boolean)
  return (words.length > 1 ? words[0][0] + words[1][0] : (words[0] ?? '?').slice(0, 2)).toUpperCase()
}

function toneFor(name = '') {
  let hash = 0
  for (const ch of name) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0
  return TONES[hash % TONES.length]
}

// Discord avatar with an initials fallback if there is none or it fails to
// load, or a plain person icon with `fallback="icon"`.
export function Avatar({ src, name, size = 'md', className, decorative = false, fallback = 'initials' }) {
  const [failed, setFailed] = useState(false)
  const label = decorative ? '' : name
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={label}
        onError={() => setFailed(true)}
        className={cn('shrink-0 rounded-full object-cover ring-1 ring-white/10', SIZES[size], className)}
      />
    )
  }
  return (
    <span
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : name}
      aria-hidden={decorative ? 'true' : undefined}
      className={cn(
        'grid shrink-0 place-items-center rounded-full font-semibold ring-1 ring-white/10',
        fallback === 'icon' ? 'bg-white/5 text-ink-muted' : toneFor(name),
        SIZES[size],
        className,
      )}
    >
      {fallback === 'icon' ? <UserRound aria-hidden="true" className="size-1/2" /> : initials(name)}
    </span>
  )
}
